import React, { useState } from "react"
import PropTypes from "prop-types";
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Select, Typography } from "@mui/material"
import { useTranslation } from "react-i18next";
import localizationKeys from "../../../i18n/localizationKeys";
import { DialogCancelButton, DialogOKButton } from "./dialogStyles";

export const GroupSelectDialog = ({channelGroups, open, handleClose, handleOk}) => {
  const {t} = useTranslation();
  const displayChannelGroups = channelGroups.slice(1); // All channels is not target for add channels
  const [selectedValue, setSelectedValue] = useState();
  return (
    <Dialog onClose={() => {handleClose(); setSelectedValue(null)}} open={open}
      slotProps={{
        paper: {
          sx: {
            backgroundColor: "#161a1e",
          }}}}
    >
      <DialogTitle sx={{color: "white"}}>{t(localizationKeys.ChannelGroupChooseGroupDialogMessage1)}</DialogTitle>
      <Typography sx={{color: "white", textAlign: "center"}}>{t(localizationKeys.ChannelGroupChooseGroupDialogMessage2)}</Typography>
      <DialogContent>
        <Box sx={{width: "100%", backgroundColor: "#252d39"}}>
          <Select 
            displayEmpty 
            onChange={(e) => setSelectedValue(e.target.value)} 
            sx={{width: "100%", color: selectedValue ? "rgba(255,255,255, 1)" : "rgba(255,255,255,0.5)" }}
            MenuProps={{slotProps: {paper: {sx: {backgroundColor: "#252d39", color: "white"}} ,list: {sx:{backgroundColor: "#252d39"}}}}} 
            renderValue={(value) => value ? value.name : t(localizationKeys.ChannelGroupSelectGroupDialogSelectGroup)}
          >
            {
              displayChannelGroups.map((group) => (
                <MenuItem key={group.id} value={group} sx={{backgroundColor: selectedValue === group.id ? "rgba(25, 118, 210, 0.08)" : "#252d39", "&:hover": {backgroundColor: "rgba(25, 118, 210, 0.08)"}}}>{group.name}</MenuItem>
              ))
            }
          </Select>
        </Box>
      </DialogContent>
      <DialogActions sx={{justifyContent: "center"}}>
        <DialogCancelButton onClick={handleClose}>{t(localizationKeys.CancelButtonText)}</DialogCancelButton>
        <DialogOKButton variant="contained" disabled={!selectedValue} onClick={() => {handleOk(selectedValue)}}>{t(localizationKeys.ChannelGroupSelectGroupDialogAddToGroupButton)}</DialogOKButton>
      </DialogActions>
    </Dialog>
  )
}

GroupSelectDialog.propTypes = {
  channelGroups: PropTypes.array.isRequired,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  handleOk: PropTypes.func,
}